// extracted by mini-css-extract-plugin
export default {"button":"EditButton_button__eu3h9","icon":"EditButton_icon__vpwiP"};